// extracted by mini-css-extract-plugin
export default {"closableWrapper":"HeaderClosable_closableWrapper__BQRsb"};